var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendrieTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07274 1.75C6.43662 1.75 6.7316 2.03368 6.7316 2.38362V3.66176C7.31602 3.65086 7.9711 3.65086 8.70817 3.65086H12.2221C12.9591 3.65086 13.6142 3.65086 14.1986 3.66176V2.38362C14.1986 2.03368 14.4936 1.75 14.8575 1.75C15.2213 1.75 15.5164 2.03368 15.5164 2.38362V3.71782C16.7808 3.81519 17.6109 4.05416 18.2206 4.64064C18.8305 5.22712 19.079 6.02539 19.1803 7.24138L19.25 7.875H2.55899H1.75V7.24138C1.85125 6.02539 2.09974 5.22712 2.70957 4.64064C3.31941 4.05416 4.14948 3.81519 5.41389 3.71782V2.38362C5.41389 2.03368 5.70887 1.75 6.07274 1.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.2496 12.2501V10.5001C19.2496 9.76588 19.2468 8.45711 19.2355 7.875H1.75803C1.74673 8.45711 1.74959 9.76588 1.74959 10.5001V12.2501C1.74959 15.5499 1.74959 17.1998 2.77471 18.2249C3.79984 19.2501 5.44976 19.2501 8.74959 19.2501H12.2496C15.5495 19.2501 17.1994 19.2501 18.2245 18.2249C19.2496 17.1998 19.2496 15.5499 19.2496 12.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendrieTransparent);
export default __webpack_public_path__ + "static/media/calendrieTransparent.3707d9cc51ea46abcf8bc965fed1eb63.svg";
export { ForwardRef as ReactComponent };